import React from 'react';
import TextComponent from 'shared/components/TextComponent';

const LengthText = (props) => {
  const {
    name,
    label,
    parameters,
    required,
    tooltip,
    groupName,
    onChangeParameter,
    onChange,
    children,
  } = props;

  const defaultChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label={label}
      name={name}
      value={parameters[name] || ''}
      required={required}
      onChange={onChange || defaultChange}
      tooltip={tooltip}
      groupName={groupName}>
      {children}
    </TextComponent>
  );
};

LengthText.defaultProps = {
  required: true,
  label: 'Carrier Length ',
  name: 'carrier_length',
};

export default LengthText;
